import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Input,
  FormFeedback,
  Label,
  Col,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesConcesionarios,
  resourcesRoutes,
} from "../../../helpers/backend_helper";
import { getStorageCompany } from "../../../helpers/api_helper";
import { Alert } from "../../../helpers/alerts/alertHelper";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";
import ValidatePhone from "./ValidatePhone";
import ValidateEmail from "./ValidateEmail";

const CATEGORIA = [
  {id:'Socio'},
  {id:'Arrendatario'},
];

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
}) => {
  const company = getStorageCompany();
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState([]);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      name: Yup.string().nullable(true).required("Requerido"),
      lname1: Yup.string().nullable(true).required("Requerido"),
      lname2: Yup.string().nullable(true).required("Requerido"),
      email: Yup.string().email().nullable(true),
      phone: Yup.string().nullable(true),
      cellphone: Yup.string().nullable().matches(/^\d{10}$/, 'Teléfono debe contener 10 dígitos'),
      local_phone: Yup.string().nullable(true),
      route_id: Yup.string().nullable(true).required("Requerido"),
      code: Yup.string().nullable(true),
      email_verified_at: Yup.string().nullable(true),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  const save = async (data) => {
    console.log('saving concesionario', { data });
    try {
      setLoading(true);
      const response = modal.update
        ? await resourcesConcesionarios("put", data, data.id)
        : await resourcesConcesionarios("post", data);
      responseAction(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.concesionario;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response.data.errors);
    }
  };

  useEffect(() => {
    if (authUser.profile_id != 3) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Agregar"} Concesionario
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              {authUser.profile_id == 2 && (
                <div className="col-sm-12">
                <label className="form-label">Ruta:</label>
                <Select
                  className={classNames({'is-invalid': (validation.touched.route_id && validation.errors.route_id)})}
                  classNamePrefix="select"
                  isClearable={true}
                  value={ routes.filter(e => e.id == validation.values.route_id)[0] ?? null }
                  isSearchable={true}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option.id}`}
                  name="route_id"
                  options={routes}
                  onChange={(option, meta) => {validation.setFieldValue('route_id', option.id, true)}}
                />
                <FormFeedback type="invalid">{validation.errors.route_id}</FormFeedback>
                </div>
              )}
              <NibbleInput
                md={6}
                label="Nombre(s):"
                fieldName="name"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Apellido paterno:"
                fieldName="lname1"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Apellido materno:"
                fieldName="lname2"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Fecha de nacimiento:"
                fieldName="fec_nac"
                fieldType="date"
                validation={validation}
              />
              {validation.values.id ? (
                <Col className="mt-2" md={6}>
                  <Label className="form-label">Correo electrónico:</Label>
                  <div className={`input-group ${validation.errors.email && 'is-invalid'}`}>
                    <Input
                      className="form-control"
                      name="email"
                      type="text"
                      onChange={e => {
                        validation.setValues({
                          ...validation.values,
                          email: e.target.value,
                          email_verified_at: null,
                        })
                      }}
                      onBlur={validation.handleBlur}
                      value={validation.values.email}
                      invalid={validation.errors.email}
                    />
                    <ValidateEmail userValidation={validation} />
                  </div>
                  <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                </Col>
              ) : (
                <NibbleInput
                  md={6}
                  label="Correo electrónico:"
                  fieldName="email"
                  fieldType="text"
                  validation={validation}
                />
              )}
              {validation.values.id ? (
                <Col className="mt-2" md={6}>
                  <Label className="form-label">Teléfono móvil:</Label>
                  <div className={`input-group ${validation.errors.cellphone && 'is-invalid'}`}>
                    <Input
                      className="form-control"
                      name="cellphone"
                      type="text"
                      onChange={e => {
                        validation.setValues({
                          ...validation.values,
                          cellphone: e.target.value,
                          phone_validated: 0,
                        })
                      }}
                      onBlur={validation.handleBlur}
                      value={validation.values.cellphone}
                      invalid={validation.errors.cellphone}
                    />
                    <ValidatePhone userValidation={validation} />
                  </div>
                  <FormFeedback type="invalid">{validation.errors.cellphone}</FormFeedback>
                </Col>
              ) : (
                <NibbleInput
                  md={6}
                  label="Teléfono móvil:"
                  fieldName="cellphone"
                  fieldType="number"
                  validation={validation}
                />
              )}              
              <NibbleInput
                md={6}
                label="Teléfono local:"
                fieldName="local_phone"
                fieldType="number"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Categoría:"
                fieldName="category"
                fieldType="select"
                selectItems={CATEGORIA ?? []}
                validation={validation}
                selectOptionLabel={ (option) => `${option.id}` }
                selectOptionValue={ (option) => option.id }
              />
              <NibbleInput
                md={6}
                label="Clave:"
                fieldName="code"
                fieldType="text"
                validation={validation}
              />
				    </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
